var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gotopshow)?_c('div',{staticClass:"gotop",on:{"click":_vm.gototop}},[_c('span',{staticClass:"iconfont icon-stack"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }